module.exports = __webpack_public_path__ + "img/head-kids.e89f768d.png";